module.exports = __webpack_public_path__ + "img/list-pattern3.bf2c7a9.svg";